<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div style="text-align: left;" class="clause">
        <p style="font-size:12pt; line-height:150%; margin:0pt; text-align:center"><span style="font-family:宋体; font-size:12pt">用户信息授权协议</span></p>
        <p style="font-size:12pt; line-height:150%; margin:0pt"><span style="font-family:宋体; font-size:12pt; font-weight:bold">重要提示：</span></p>
        <p style="font-size:12pt; line-height:150%; margin:0pt"><span style="font-family:宋体; font-size:12pt">《</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">用户</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">信</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">息授权</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">协议</span><span style="font-family:宋体; font-size:12pt">》(以下简称“本</span><span style="font-family:宋体; font-size:12pt">协议</span><span style="font-family:宋体; font-size:12pt">”)是</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">【渠道方公司】</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">（以下简称为“贵司”、“我们”）</span><span style="font-family:宋体; font-size:12pt">与您所订立的有效合约。</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">根据《中华人民共和国个人信息保护法》等法律法规要求，为保障您的合法权益，请您务必审慎阅读、充分理解本</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">协议</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">的全部条款，特别是授权条款或限制您权利的条款，这些条款以加粗形式提示您注意。</span></p>
        <p style="font-size:12pt; line-height:150%; margin:0pt"><span style="font-family:宋体; font-size:12pt; font-weight:bold">您勾选同意本</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">协议</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">前应核实本</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">协议</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">全部内容。本</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">协议</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">一经您勾选</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">或者点击</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">，即视为您已阅读并同意本</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">协议</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">全部条款。</span></p>
        <p style="font-size:12pt; line-height:150%; margin:0pt"><span style="font-family:宋体; font-size:12pt; font-weight:bold">贵司：</span></p>
        <p style="font-size:12pt; line-height:150%; margin:0pt; text-indent:0pt"><span style="font-family:宋体; font-size:12pt">1、</span><span style="font-family:宋体; font-size:12pt">您授权我们将</span><span style="font-family:宋体; font-size:12pt; text-decoration:underline">您的</span><span style="font-family:宋体; font-size:12pt; font-weight:bold; text-decoration:underline">姓名、</span><span style="font-family:宋体; font-size:12pt; font-weight:bold; text-decoration:underline">身份证号、手机号以及您本人担任法定代表人/负责人/经营者的企业（下称“名下企业”）的企业信息（企业全称、企业统一社会信用代码等）以及</span><span style="font-family:宋体; font-size:12pt; font-weight:bold; text-decoration:underline">名下企业的交易信息、发票信息、税务信息</span><span style="font-family:宋体; font-size:12pt; font-weight:bold; text-decoration:underline">、</span><span style="font-family:宋体; font-size:12pt; font-weight:bold; text-decoration:underline">其他企业经营信息</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">（</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">以上统称为</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">“信息”）</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">【</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">自行或者委托合作机构</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">】</span><span style="font-family:宋体; font-size:12pt">提供给</span><span style="font-family:宋体; font-size:12pt; font-weight:bold; text-decoration:underline">上海拍拍贷金融信息服务有限公司、上海耳序信息技术有限公司及其关联公司</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">（以下称“第三方”）</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">，第三方联系方式：9</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">5065</span><span style="font-family:宋体; font-size:12pt">。</span></p>
        <p style="font-size:12pt; line-height:150%; margin:0pt"><span style="font-family:宋体; font-size:12pt; font-weight:bold">以方便您正常</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">、</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">完整使用第三方提供的产品及服务</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">（下称“第三方服务”）</span><span style="font-family:宋体; font-size:12pt">。</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">同时</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">，</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">您授权第三方将您使用第三方服务期间的申请结果信息</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">（【申请状态、是否通过、贷款金额】）提供给我们，以方便我们与第三方的合作正常进行。</span></p>
        <p style="font-size:12pt; line-height:150%; margin:0pt"><span style="font-family:宋体; font-size:12pt">2、</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">当您使用第三方服务</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">时</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">：我们依据您的授权，将您的信息提供给第三方，使您能够正常、完整使用第三方服务。</span></p>
        <p style="font-size:12pt; line-height:150%; margin:0pt"><span style="font-family:宋体; font-size:12pt; font-weight:bold">您使用第三方服务时，我们只会向第三方提供您授权同意的信息项。如果第三方因业务需要，需超出前述授权范围使用您的信息，该第三方需征求您的同意</span><span style="font-family:宋体; font-size:12pt">。</span></p>
        <p style="font-size:12pt; line-height:150%; margin:0pt"><span style="font-family:宋体; font-size:12pt">3、我们作为依据您的明确授权向第三方提供您的上述信息，第三方向您提供的服务由该第三方独立运营并承担责任。</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">因第三方使用您上述信息而产生的纠纷，我们将协调您与第三方协商解决。</span></p>
        <p style="font-size:12pt; line-height:150%; margin:0pt"><span style="font-family:宋体; font-size:12pt">4、</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">如我们对本协议进行变更，我们将通过官网公告或站内信等方式发出更新提示，更新内容将于公告或通知载明的生效之日起开始生效。</span><span style="font-family:宋体; font-size:12pt">若您无法同意变更后的协议内容，您有权停止使用相关服务。</span></p>
        <p style="font-size:12pt; line-height:150%; margin:0pt"><span style="font-family:宋体; font-size:12pt">5、本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生的争议，双方应尽量友好协商解决，如协商不成的，</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">您同意将相关争议提交至</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">【渠道方公司】实际经营地【经营所在城市及地区】人民法院</span><span style="font-family:宋体; font-size:12pt; font-weight:bold">诉讼解决</span><span style="font-family:宋体; font-size:12pt">。</span></p>
        <p style="font-size:10.5pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span style="font-family:等线; font-size:10.5pt">&nbsp;</span></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color {
  width: 100%;
  height: 100%;
}
.crossBox {
  text-align: right;
}
.cross {
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause {
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: "微软雅黑";
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  /* text-indent: 6px; */
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
